module.exports = __webpack_public_path__ + "img/logo_white.ee55547c.png";